import { app } from '../../../../app';
import { Controller } from './new-company.controller';

app.component('companyResellerNewCompany', {
    bindings: {
        account: '<',
        administrators: '<',
        appType$:'<',
        appTypes$:'<',
        companyId:'<',
        companyId:'<',
        createdCompany:'<'
    },
    controller: Controller,
    templateUrl: require('./new-company.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/new-company/new-company.component.js